export const getPreferredCmpInternalLandingPath = ({
  allowedPaths,
  preferredPaths,
}: {
  allowedPaths: string[];
  preferredPaths: readonly string[];
}): string | null =>
  preferredPaths.find((path) => allowedPaths.includes(path)) ||
  allowedPaths[0] ||
  null;
